<div class="inbox-edition edition-section">
    <div class="div-edition">
        <mat-icon matIconPrefix class="material-icons-outlined icon-edition">edit</mat-icon>
        <span class="text-edition">En Edición por mi</span>
        <a  *ngIf="canPermissionTeam" class="change-inbox" (click)="showInboxEdition()">
            Por mi Equipo
        </a>
    </div>
    <div class = "search-section">
        <mat-form-field class="search-well-card dense-3">
            <mat-label class = "label-well">Buscá un pozo</mat-label>
            <input type="text" value={{textSearch}} aria-label="Well" 
            matInput #searchText (keyup.enter)="getHandoversHomeEditionPersonalWithFilter(searchText.value)">
            <span matSuffix class="cursor-pointer" (click)="getHandoversHomeEditionPersonalWithFilter(searchText.value)">
              <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
            </span>
        </mat-form-field> 
    </div>
    <div class="content-section">
        <div class="handovers" *ngIf="totalHandoversEdition != 0">
            <app-handover-card *ngFor="let handover of handoversEdition" [handover]="handover"
                (reload)="eventReload($event)">
            </app-handover-card>
        </div>
        <div class="empty-content" *ngIf="totalHandoversEdition == 0">
            <div *ngIf="this.textSearch == ''">
                <p class="edition-empty">No hay Handovers aún</p>
                <p class="edition-empty-text">Cuando estés editando un <br> Handover podrás visualizarlo acá</p>
            </div>
            <div *ngIf="this.textSearch != ''">
                <p class="edition-empty">No hay handovers para el filtro aplicado</p>
            </div>
        </div>
    </div>
</div>